import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow pt-4 max-w-7xl mx-auto" }
const _hoisted_2 = { class: "md:flex justify-between items-center border-b px-4 md:px-6 pb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "Create Shortlist"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "Let's get this deal in front of the right humans for the job.")
], -1)
const _hoisted_4 = { class: "flex justify-start md:justify-end items-center mt-4 md:mt-0" }
const _hoisted_5 = { class: "md:flex justify-between items-center border-b px-4 md:px-6 py-4" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "text-base font-medium" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "inline-flex items-center justify-center rounded-md border bg-white hover:bg-gray-50 text-gray-600 px-3 py-2 w-28 text-sm font-medium focus:outline-none"
}, " Templates ", -1)
const _hoisted_9 = { class: "divide-y" }
const _hoisted_10 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_base_menu_toggle = _resolveComponent("base-menu-toggle")!
  const _component_lenders_matching_plain = _resolveComponent("lenders-matching-plain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(["px-3 py-2 bg-white border text-sm rounded-md hover:border-gray-400 mr-2 flex items-center", { 'opacity-50 pointer-events-none': !_ctx.om.id }]),
          to: `/offering-memorandum/${_ctx.om.id || ''}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_EyeIcon, { class: "w-4 h-4 mr-1" }),
            _createTextVNode(" Preview ")
          ]),
          _: 1
        }, 8, ["class", "to"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["px-3 py-2 bg-indigo-100 hover:bg-sky text-sky hover:text-white text-sm rounded-md flex items-center", { 'opacity-50 pointer-events-none': !_ctx.distributions.length }]),
          to: { name: 'deal-om-tracker' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckIcon, { class: "w-4 h-4 mr-1" }),
            _createTextVNode(" Review shortlist ")
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, "Selected: " + _toDisplayString(_ctx.distributions.length), 1),
        (_ctx.distributions.length)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#clear",
              class: "text-xs text-sky font-bold ml-2 pt-0.5",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.clearOriginatorsList()), ["prevent"]))
            }, " Clear selection "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_base_menu_toggle, { "menu-styles": 'top right-0 sm:mt-2 sm:p-0' }, {
          toggle: _withCtx(() => [
            _hoisted_8
          ]),
          items: _withCtx(() => [
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, ({ label, icon, modal, key, disabled }) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "px-4 py-2",
                  key: key
                }, [
                  _createElementVNode("a", {
                    href: `#${key}`,
                    onClick: _withModifiers(($event: any) => (_ctx.showModal(modal)), ["prevent"]),
                    class: _normalizeClass(["text-sm flex items-center whitespace-nowrap flex items-center justify-between", { 'opacity-50 pointer-events-none': disabled }])
                  }, [
                    _createTextVNode(_toDisplayString(label) + " ", 1),
                    (_openBlock(), _createBlock(_resolveDynamicComponent(icon), { class: "w-4 h-4 text-indigo-600 ml-2" }))
                  ], 10, _hoisted_10)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_lenders_matching_plain)
  ]))
}